import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import HomeCollage from '../components/HomeCollage';
import {
  loadCollageOrganizations
} from '../actions';
import LeaderSpotlightIntro from '../components/leaderStory/LeaderSpotlightIntro';
import LeaderSpotlightForm from '../components/leaderStory/LeaderSpotlightForm';


class LeaderSpotlight extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    formSubmitted: false,
    whichPage: 'intro',
  }

  setFormStatus = (status) => {
    this.setState({formSubmitted: status});
  }
  setWhichPage = (page) => {
    if (typeof(window) !== "undefined") {
      window.scrollTo(0,0)
    }
    this.setState({whichPage: page});
  }

  componentWillMount() {
    if (typeof(window) !== "undefined") {
      window.scrollTo(0,0)
    }
  }

  render() {
    let buttonCollage = 'Share your story with us'; 
    let pageMarkup = '';
    if(this.state.whichPage == 'intro') {
      pageMarkup = <LeaderSpotlightIntro setWhichPage={this.setWhichPage} />
    } else if(this.state.whichPage == 'form') {
      pageMarkup = <LeaderSpotlightForm setFormStatus={this.setFormStatus} 
      setWhichPage={this.setWhichPage} />
    } else if(this.state.formSubmitted && this.state.whichPage == 'thankyou') {
      pageMarkup = <div style={{marginBottom: '10.0rem'}}><h1 className="page-heading" style={{padding: '1rem 0 1.0rem 2.5rem'}}>Thank you!</h1><p>Thank you for sharing your story with the WorldWideWomen community. We will reach out to you if we have any questions, and we will let you know when your story and organization will be featured in our <i>Fearless Female Friday</i> weekly email. Please email <a href="mailto:mbroderick@worldwidewomen.co">Maureen Broderick</a> if you have any questions for us.</p><p>Women Rock the Universe!</p><p>The WorldWideWomen team</p></div>
    }

    return(
      <main>
        <div className="content-wrapper">
          <HomeCollage collageOrganizations={this.props.collageOrganizations}
                          loadCollageOrganizations={this.props.loadCollageOrganizations}
                          browser={this.props.browser}
                          auth={this.props.auth}
                          buttonCollage={buttonCollage}
                          header='Leader Spotlight'
                          />

          <div className="sharedStory-outerWrapper">
            {pageMarkup}
          </div>
        </div>
      </main>
    )
  }
}

function mapStateToProps(state) {
  return state;
 }
 
 
 
 export default connect(
   mapStateToProps,
   {
     loadCollageOrganizations,
  })(LeaderSpotlight);


// WEBPACK FOOTER //
// ./src/containers/LeaderSpotlight.jsx